import { useState } from "react";
import { supabase } from "../supabase/supabaseClient";
import { useUser } from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";

export default function OpportunityNewPage() {
  const { user } = useUser();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "",
    category: "open-call",
    host: "",
    region: "",
    deadline: "",
    url: "",
    description: "",
  });

  if (!user || user.userType !== "admin") {
    return <div className="p-6">Access denied.</div>;
  }

  async function handleSubmit(e: any) {
    e.preventDefault();

    const { error } = await supabase.from("opportunities").insert([
      {
        ...form
      },
    ]);

    if (error) {
      alert("ERROR: " + error.message);
      return;
    }

    alert("Created successfully!");
    navigate("/opportunities");
  }

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Add Opportunity</h1>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        
        <input
          className="border px-3 py-2 rounded"
          placeholder="Title"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
        />

        <select
          className="border px-3 py-2 rounded"
          value={form.category}
          onChange={(e) => setForm({ ...form, category: e.target.value })}
        >
          <option value="open-call">Open Call</option>
          <option value="residency">Residency</option>
          <option value="international">International</option>
          <option value="study-abroad">Study Abroad</option>
        </select>

        <input
          className="border px-3 py-2 rounded"
          placeholder="Host"
          value={form.host}
          onChange={(e) => setForm({ ...form, host: e.target.value })}
        />

        <input
          className="border px-3 py-2 rounded"
          placeholder="Region (KR, JP, US…)"
          value={form.region}
          onChange={(e) => setForm({ ...form, region: e.target.value })}
        />

        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={form.deadline}
          onChange={(e) => setForm({ ...form, deadline: e.target.value })}
        />

        <input
          className="border px-3 py-2 rounded"
          placeholder="URL"
          value={form.url}
          onChange={(e) => setForm({ ...form, url: e.target.value })}
        />

        <textarea
          className="border px-3 py-2 rounded min-h-[120px]"
          placeholder="Description"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
        />

        <button
          type="submit"
          className="px-4 py-2 bg-black text-white rounded mt-2"
        >
          Submit
        </button>
      </form>
    </div>
  );
}
